import i18n from '@/assets/lang'
import { useDemoStore } from "@/pinia/index";
import { ElMessage, ElMessageBox } from 'element-plus';
const store = useDemoStore();

/**
 * 格式化时间函数
 * @param { String } time - 时间戳
 * @param { String } state - 返回时间格式 ["Y-M-D h:m:s","Y-M-D","yyyy","mm","Y-M"]
 * @returns { String } 返回指定格式下的时间
 */
export const ftime = (time, state) => {
    let date = new Date(time);
    let Y = date.getFullYear();
    let M = date.getMonth() + 1;
    let D = date.getDate();
    let h = date.getHours();
    let m = date.getMinutes();
    let s = date.getSeconds();
    M = M < 10 ? "0" + M : M;
    D = D < 10 ? "0" + D : D;
    h = h < 10 ? "0" + h : h;
    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;
    if (state == 'Y-M-D h:m:s') {
        return `${Y}-${M}-${D} ${h}:${m}:${s}`;
    } else if (state == 'Y-M-D') {
        return `${Y}-${M}-${D}`;
    } else if (state == 'yyyy') {
        return `${Y}`
    } else if (state == 'mm') {
        return `${M}`
    } else if (state == 'Y-M') {
        return `${String(Y).slice(2)}-${M}`
    }
}



/**
 * 支付方式转换
 * @param { String } x - PAYPAL
 * @param { String }  y - TT
 * @param { String }  z - WU
 * @returns 返回支付类型
 */
export const fPayment = (x, y, z) => {
    let paymentInfo = ''
    if (!!x && !y && !z) {
        paymentInfo = 'PAYPAL'
    } else if (!x && !!y && !z) {
        paymentInfo = 'TT'
    } else if (!x && !y && !!z) {
        paymentInfo = 'WU'
    }
    return paymentInfo
}



/**
 * 浮点数保留小数
 * @param { Number } src  - 数据
 * @param { Number }   pos  - 保留位数
 * @returns 返回处理后的数据
 */
export const fomatFloat = (src, pos) => {
    let num = Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);
    let arrayNum = String(num).split('.')
    if (!/\./.test(num)) {
        num += '.' + '0'.repeat(pos);
    } else if (arrayNum[1].length < 2) {
        num += '0'.repeat(pos - arrayNum[1].length);
    }
    return num
}



/**
 * 货币转换
 * @param  { String } current - 货币类型
 * @returns 返回货币符号
 */
export const currencType = (current) => {
    let currencySymbol = ''
    if (current == 'USD') {
        currencySymbol = '$';
    } else if (current == 'CNY') {
        currencySymbol = '￥';
    } else if (current == 'EUR') {
        currencySymbol = '€';
    } else if (current == 'GBP') {
        currencySymbol = '￡';
    } else if (current == 'CAD') {
        currencySymbol = 'C$';
    } else if (current == 'AUD') {
        currencySymbol = 'A$';
    } else if (current == 'HKD') {
        currencySymbol = 'HK$';
    } else if (current == 'RUB') {
        currencySymbol = '₽'
    }
    return currencySymbol
}



/**
 * 防抖
 * @param { String }  count  - 延迟时间
 * @param { Function } callback  - 回调函数
 * @returns 
 */
export const debounce = (count, callback) => {
    return (() => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            callback();
        }, count);
    })()
}
let timer = null;




/**
 * 判断对象是否相等
 * @param { object } a  - 对象1
 * @param { object } b - 对象2
 * @returns 不相等返回false
 */
export const isObjectValueEqual = (a, b) => {
    // 判断两个对象是否指向同一内存，指向同一内存返回 true
    if (a == b) return true
    // 获取两个对象键值数组
    let aProps = Object.getOwnPropertyNames(a)
    let bProps = Object.getOwnPropertyNames(b)
    if (aProps.length != bProps.length) return false
    for (let prop in a) {
        // 判断 a 的键值，在 b 中是否存在，不存在，返回 false
        if (b.hasOwnProperty(prop)) {
            if (typeof a[prop] == 'object') {
                if (!isObjectValueEqual(a[prop], b[prop])) return false
            } else if (a[prop] != b[prop]) {
                return false
            }
        } else {
            return false
        }
    }
    return true
}

/**
 * 合并数组相同的keyName的数据
 * @param {object} arr - 处理的数组 
 * @param {String} keyName - 用于判断相同的键名
 * @param {Number} valueName - 用于计算的键值 
 * @param {Number} mergeKey - 用于判断state是否已经订货
 * @param {String} ReservedID - 保留项，传入的数组keyName相同有值合并时以有ReservedID为主合并，都没有随意合并，相同的keyName有多个ReservedID以有值的第一项合并
 * @returns 返回合并后的数组
 */
export const delSomeObjValue = (arr, keyName, valueName, mergeKey, ReservedID) => {
    const groupArr = {}; // 按照keyName分组后的数组
    const resultArr = []; // 最终结果数组
    // 将传入的数组按keyName进行分组
    for (let i = 0; i < arr.length; i++) {
        const key = arr[i][keyName];
        if (!groupArr[key]) {
            groupArr[key] = [];
        }
        groupArr[key].push(arr[i]);
    }
    // 遍历分组后的数组进行合并操作
    for (const key in groupArr) {
        const group = groupArr[key];
        const mergeArr = group.filter(item => item[mergeKey] == 1 || !item[mergeKey]);
        const remainArr = group.filter(item => item[mergeKey] != 1);//状态不等于不合并
        // 判断是否需要合并
        if (mergeArr.length > 1) {
            let mergedObj;
            if (ReservedID) {
                const reservedItems = mergeArr.filter(item => item[ReservedID]); //获取数组有ReservedID值的项
                if (reservedItems.length > 0) { //如果有多个ReservedID有值则以第一个为主合并
                    let reservedItem = reservedItems[0];
                    reservedItem[valueName] = mergeArr.reduce((sum, item) => (sum += Number(item[valueName])), 0)
                    mergedObj = reservedItem
                } else {
                    mergedObj = mergeArr.reduce((prev, curr) => {
                        prev[valueName] = (Number(prev[valueName]) || 0) + (Number(curr[valueName]) || 0);
                        return prev;
                    });
                }
            } else {
                mergedObj = mergeArr.reduce((prev, curr) => {
                    prev[valueName] = (Number(prev[valueName]) || 0) + (Number(curr[valueName]) || 0);
                    return prev;
                });
            }
            resultArr.push(mergedObj, ...remainArr);
        } else {
            resultArr.push(...group)
        }
    }
    return resultArr;
}

/**
 * 判断对象内的值是否有空值,用于表单校验
 * @param { object }  obj - 对象
 * @param { object } emptyProps - 需要忽略的属性数组
 * @returns 有空值返回该属性名
 */
export const hasEmptyProp = (obj, emptyProps = []) => {
    for (let prop in obj) {
        const value = obj[prop];
        if ((value == '' || typeof value == 'undefined' || value == null) && !(emptyProps?.includes(prop))) {
            return prop;
        }
        // 数组
        if (Array.isArray(value)) {
            let key = prop
            if (value.length == 0) {
                return key
            }
            for (let i = 0; i < value.length; i++) {
                if (typeof value[i] == 'object') {
                    if (hasEmptyProp(value[i], emptyProps) != 1) {
                        return `${i + 1}${hasEmptyProp(value[i], emptyProps)}`
                    }
                }
            }
        }
        // 对象
        if (typeof value == 'object') {
            if (hasEmptyProp(value, emptyProps) != 1) {
                return hasEmptyProp(value, emptyProps)
            }
        }
    }
    return 1
}



/**
* 多层数组添加状态添加状态
* @param { object }  List - 数组
* @returns  处理后的数组
*/

export const addStatus = (List) => {
    for (let i = 0; i < List.length; i++) {
        if (List[i].child && List[i].child.length > 0) {
            List[i].status = "open"; // 添加状态字段
            addStatus(List[i].child); // 递归遍历子节点
        } else {
            List[i].status = "closed"; // 添加状态字段
        }
    }
    return List
}




/**
 * 批量照片转base64格式
 * @param { object } imagePaths  - 照片本地地址数组
 * @returns 返回一个Promise
 */
export const imagesTobase64 = (imagePaths = []) => {
    imagePaths = imagePaths.map(item => item = `/img/${item}`)
    const base64Images = []
    let count = 0
    return new Promise((resolve, reject) => {
        for (let i = 0; i < imagePaths.length; i++) {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                canvas.width = img.width
                canvas.height = img.height
                ctx.drawImage(img, 0, 0)
                const base64 = canvas.toDataURL('image/png')
                base64Images[i] = base64
                count++
                if (count == imagePaths.length) {
                    resolve(base64Images)
                }
            }
            img.onerror = () => {
                reject('图片转base64失败')
            }
            img.src = imagePaths[i]
        }
    })
}

/**
 * 
 * @returns url拼接函数，生产环境和开发环境自动更换
 */
export const concatenatedURL = () => {
    let isDev = store.context
    let baseURL
    if (Number(isDev) == 0) {
        baseURL = 'http://f-api.files99.com'
    } else if (Number(isDev) == 2) {
        if (store.server == 'cn') { //中国
            baseURL = 'https://cn-f-api-produce.files99.com'
        } else if (store.server == 'de') { //德国
            baseURL = 'https://de-f-api-produce.kernal.net'
        } else if (store.server == 'us') { //美国
            baseURL = 'https://us-f-api-produce.kernal.net'
        }
    }
    return baseURL
}
/**
 * 惩罚奖励赔偿状态码转换
 * @param { Number } info  - 状态码
 * @returns 类型
 */
export const fPayState = (info) => {
    let type = ''
    if (info == 1) {
        type = '赔偿 '
    } else if (info == 2) {
        type = '奖励 '
    } else if (info == 3) {
        type = '惩罚'
    }
    return type
}
/**
 * 金额输入框限制输入函数
 * @param {number} value - 输入的值 
 * @param {string} name - 值的变量名
 * @param {object} obj - 值的外层对象 
 * @param {Function} callback -需要执行的函数
 * @param {*} index  - obj是数组传索引，对象传NaN
 */
export const MoneyInput = (value, name, obj, index,) => {
    let floatingNumber = "" + value
    if (floatingNumber.split('.')[1] && floatingNumber.split('.')[1].length > 2) {
        clearTimeout(moneyTimer);
        moneyTimer = setTimeout(() => {
            ElMessage({ message: i18n.global.t('Order.orderEnterOnlyTwo'), type: 'warning' })
        }, 500);
    }
    floatingNumber = floatingNumber.replace(/[^\d^\.]+/g, "").replace(/^0+(\d)/, "$1")
        .replace(/^\./, "0.").match(/^\d*(\.?\d{0,2})/g)[0] || ""
    if (Number(floatingNumber) > 99999999.99) {
        if (floatingNumber.split('.')[1]) {
            floatingNumber = `${floatingNumber.split('.')[0].slice(0, 8)}.${floatingNumber.split('.')[1].slice(0, 2)}`
        } else {
            floatingNumber = floatingNumber.split('.')[0].slice(0, 8)
        }
        clearTimeout(moneyTimer);
        moneyTimer = setTimeout(() => {
            ElMessage({ message: `${i18n.global.t('Order.orderGreaterCannot')}99999999.99`, type: 'warning' })
        }, 500);
    } else {
        floatingNumber = floatingNumber
    }
    index == 'NaN' ? obj[name] = floatingNumber : obj[index][name] = floatingNumber
}
let moneyTimer

/**
 * 重量输入框限制输入函数
 * @param {number} value - 输入的值 
 * @param {string} name - 值的变量名
 * @param {object} obj - 值的外层对象 
 * @param {*} index  - obj是数组传索引，对象传NaN
 */
export const WeightInput = (value, name, obj, index) => {
    let floatingNumber = "" + value;
    if (floatingNumber.split('.')[1] && floatingNumber.split('.')[1].length > 2) {
        clearTimeout(weightTimer);
        weightTimer = setTimeout(() => {
            ElMessage({ message: i18n.global.t('Order.orderEnterOnlyTwo'), type: 'warning' })
        }, 500);
    }
    floatingNumber = floatingNumber.replace(/^[0]+|[^\d^\.]+/g, "")
        .replace(/^0+(\d)/, "$1")
        .replace(/^\./, "0.")
        .match(/^\d*(\.?\d{0,2})/g)[0] || "";
    if (Number(floatingNumber) > 99999.99) {
        if (floatingNumber.split('.')[1]) {
            floatingNumber = `${floatingNumber.split('.')[0].slice(0, 5)}.${floatingNumber.split('.')[1].slice(0, 2)}`
        } else {
            floatingNumber = floatingNumber.split('.')[0].slice(0, 5)
        }
        clearTimeout(weightTimer);
        weightTimer = setTimeout(() => {
            ElMessage({ message: `${i18n.global.t('Order.orderGreaterCannot')}99999.99`, type: 'warning' })
        }, 500);
    } else {
        floatingNumber = floatingNumber
    }
    index == 'NaN' ? obj[name] = floatingNumber : obj[index][name] = floatingNumber
}
let weightTimer


/**
 * 数量输入框限制输入函数
 * @param {number} value - 输入的值 
 * @param {string} name - 值的变量名
 * @param {object} obj - 值的外层对象 
 * @param {*} index  - obj是数组传索引，对象传NaN
 */
export const QtyInput = (value, name, obj, index) => {
    let Integer = "" + value;
    Integer = Integer.replace(/[^0-9]/g, "").replace(/^0*0/g, "")
    if (Number(Integer) > 999999) {
        Integer = Integer.slice(0, 6)
        clearTimeout(qtyTimer);
        qtyTimer = setTimeout(() => {
            ElMessage({ message: `${i18n.global.t('Order.orderGreaterCannot')}999999`, type: 'warning' })
        }, 500);
    } else {
        Integer = Integer
    }
    index == 'NaN' ? obj[name] = Integer : obj[index][name] = Integer
}
let qtyTimer



/**
 * 数量输入框限制输入函数
 * @param {number} value - 输入的值 
 * @param {string} name - 值的变量名
 * @param {object} obj - 值的外层对象 
 * @param {*} index  - obj是数组传索引，对象传NaN
 * @param {number} figure -限制输入数字的极限值
 */
export const QtyInput1 = (value, name, obj, index, figure) => {
    let Integer = "" + value
    Integer = Integer.replace(/[^0-9]/g, "").replace(/^0*0/g, "")
    if (Number(Integer) > Number(figure)) {
        clearTimeout(QtyTimer)
        QtyTimer = setTimeout(() => {
            ElMessage({ message: `${i18n.global.t('Order.InputDataCannot')}${figure}`, type: 'warning' })
        }, 500)
        Integer = figure
    } else {
        Integer = Integer
    }
    obj[index][name] = Integer
}
let QtyTimer



/**
 * 比例输入框限制输入函数
 * @param {number} value - 输入的值 
 * @param {string} name - 值的变量名
 * @param {object} obj - 值的外层对象 
 * @param {*} index  - obj是数组传索引，对象传NaN
 */
export const scaleInput = (value, name, obj, index) => {
    let floatingNumber = "" + value;
    if (floatingNumber.split('.')[1] && floatingNumber.split('.')[1].length > 2) {
        clearTimeout(scaleTimer)
        scaleTimer = setTimeout(() => {
            ElMessage({ message: i18n.global.t('Order.orderEnterOnlyTwo'), type: 'warning' })
        }, 500)
    }
    floatingNumber = floatingNumber.replace(/[^\d^\.]+/g, "")
        .replace(/^0+(\d)/, "$1")
        .replace(/^\./, "0.")
        .match(/^\d*(\.?\d{0,2})/g)[0] || "";
    if (Number(floatingNumber) > 100 && !(/^100/.test(floatingNumber))) {
        if (floatingNumber.split('.')[1]) {
            floatingNumber = `${floatingNumber.split('.')[0].slice(0, 2)}.${floatingNumber.split('.')[1].slice(0, 2)}`
        } else {
            floatingNumber = floatingNumber.split('.')[0].slice(0, 2)
        }
        clearTimeout(scaleTimer)
        scaleTimer = setTimeout(() => {
            ElMessage({ message: `${i18n.global.t('Order.InputDataCannot')}100%`, type: 'warning' })
        }, 500)
    } else if (Number(floatingNumber) > 100 && (/^100/.test(floatingNumber))) {
        floatingNumber = 100
        clearTimeout(scaleTimer)
        scaleTimer = setTimeout(() => {
            ElMessage({ message: `${i18n.global.t('Order.InputDataCannot')}100%`, type: 'warning' })
        }, 500)
    } else {
        floatingNumber = floatingNumber
    }
    index == 'NaN' ? obj[name] = floatingNumber : obj[index][name] = floatingNumber
}
let scaleTimer


/**
 * 金额输入框限制输入函数
 * @param {number} value - 输入的值 
 * @param {string} name - 值的变量名
 * @param {object} obj - 值的外层对象 
 * @param {*} index  - obj是数组传索引，对象传NaN
 * @param {number} index - 限制数字
 */
export const inputMoney1 = (value, name, obj, index, figure) => {
    let floatingNumber = "" + value;
    if (floatingNumber.split('.')[1] && floatingNumber.split('.')[1].length > 2) {
        clearTimeout(moneyTimer1)
        moneyTimer1 = setTimeout(() => {
            ElMessage({ message: i18n.global.t('Order.orderEnterOnlyTwo'), type: 'warning', })
        }, 500)
    }
    floatingNumber = floatingNumber.replace(/[^\d^\.]+/g, "").replace(/^0+(\d)/, "$1").replace(/^\./, "0.").match(/^\d*(\.?\d{0,2})/g)[0] || "";
    if ((floatingNumber * 1) > (figure * 1)) {
        clearTimeout(moneyTimer1)
        moneyTimer1 = setTimeout(() => {
            ElMessage({
                message: `${i18n.global.t('Order.InputDataCannot')}${Number.isInteger(figure) ? figure : fomatFloat(figure, 2)}`,
                type: 'warning',
            })
        }, 500)
        floatingNumber = Number.isInteger(figure) ? figure : fomatFloat(figure, 2)
    } else {
        floatingNumber = Number.isInteger(floatingNumber) ? Number(floatingNumber) : floatingNumber
    }
    index == 'NaN' ? obj[name] = floatingNumber : obj[index][name] = floatingNumber
}
let moneyTimer1

/**
 * 权限数组替换key函数
 * @param {object} obj - 传入三层的处理对象
 * @param {object} keyName - 传入处理的对象的二层key
 * 返回处理后的对象，
 */

export const replaceKey = (obj = {}, keyName) => {
    let Limits = []
    for (const key1 in obj) {
        const obj1 = obj[key1].handle_auth
        const newObj1 = {}
        for (const key2 in obj1) {
            const value = obj1[key2]
            const newKey = key2.replace(/,/g, '')
            newObj1[newKey] = value
        }
        Limits[key1] = newObj1
    }
    return Limits[keyName]
}

/**
 * 资金池侧边栏暂用，需后端返回
 * @param { String } val - 侧边栏名
 * @returns 返回图标class
 */
export const Ficon = (val) => {
    let icon = ''
    if (val == '银行明细') {
        icon = 'icon-yinhangqia'
    } else if (val == 2) {//'内部转账'
        icon = 'icon-huishuaichaxun'
    } else if (val == 3) {// '转入货款'
        icon = 'icon-dingdan2'
    } else if (val == '货款入订单') {
        icon = 'icon-dingdan2'
    } else if (val == 5) { //'转出货款'
        icon = 'icon-ERP_huokuanzongjine'
    } else if (val == '库存商品') {
        icon = 'icon-kucun_crm'
    } else if (val == 7) {//'货代运费'
        icon = 'icon-yunshu1'
    } else if (val == 8) {//'雇员佣金'
        icon = 'icon-icon-test'
    } else if (val == 9) {//'房租水电网气'
        icon = 'icon-shuidianzhibao-2'
    } else if (val == 10) {//'社保公积金'
        icon = 'icon-renlishebao'
    } else if (val == 11) {//'日常报销'
        icon = 'icon-consumption'
    } else if (val == 12) { // '售后赔偿'
        icon = 'icon-bill-full'
    } else if (val == 13) { //'奖励'
        icon = 'icon-huangguan'
    } else if (val == 14) {//'惩罚'
        icon = 'icon-chufadan'
    } else if (val == '给客户退款') {
        icon = 'icon-yongjinguanli'
    } else if (val == 16) {//'退货售后账单'
        icon = 'icon-wuliaogongyingshangtuichupingshenliucheng'
    } else if (val == 17) { //'银行转账手续费'
        icon = 'icon-weidaizijinchiyuechaxun'
    } else if (val == 18) {//'银行月费年费'
        icon = 'icon-ic_commission'
    } else if (val == 19) {//'打包耗材'
        icon = 'icon-a-ziyuan701'
    } else if (val == 20) {//'换汇'
        icon = 'icon-zidongjiesuan'
    } else if (val == 21) {//'客户资金池'
        icon = 'icon-zijinchiguanli'
    } else if (val == 22) { //'不明差额'
        icon = 'icon-deletion-method'
    } else if (val == '日常开销') {
        icon = 'icon-xiaofeichangjing'
    } else if (val == 25) {//'办公设备'
        icon = 'icon-wangluo-'
    } else if (val == '产品订购订单') {
        icon = 'icon-dingdanxiangqing-dingdanzhuangtai'
    } else if (val == '产品退款订单') {
        icon = 'icon-quxiaodingdanxiao'
    } else if (val == 29) { //'收支'
        icon = 'icon-qitashouzhi'
    } else if (val == 31) { //'欠款池'
        icon = 'icon-qiankuan-fill'
    } else {
        icon = 'icon-weidingyicaidan'
    }
    return icon
}